import { enqueueRequest } from "../../../utility/ImageRequestQueue";
import { getAllImageStore, setImageEntry } from "../../../utility/indexedDBHelper";
import { migrateBase64ToBlob } from "../../../utility/migrateBase64ToBlob";

import { base64ToBlob } from "../../../utility/resizeImage";
import Hexapi from "../../../utility/HexAPI/Hexapi";


let isFetchingImages = false; 

export const fetchImagesIfVersionChanged = async (OrgPhotoVersion, hasInvalidVersion) => {
  if (isFetchingImages) {
   
    return null;
  }

  isFetchingImages = true;

  let currentVersion = OrgPhotoVersion;
  let storedVersion = localStorage.getItem("OrgPhotoVersion");
  let id = null;

  try {
    await migrateBase64ToBlob();

    let retries = 0;

    while (true) {
      if (String(currentVersion) === String(storedVersion) && !hasInvalidVersion) {
        break; 
      }

      if (retries++ > 3) {
        console.warn("Max retries reached for fetchImagesIfVersionChanged");
        break;
      }

      const imageStore = await getAllImageStore();
      const imgIDs = Object.keys(imageStore);
      if (imgIDs.length === 0) break;
      const versionimgIDs = imgIDs.map(id => imageStore[id].version);
     
const imgidss=imgIDs.join(",")
const versionidss=versionimgIDs.join(",")
const obj={
  query:`[HRApp_Droid_Proc_User_GetPhotoV2] @EmpIDs='{0}',@Vers='{1}'`,
  queryArr:[`${imgidss}`,`${versionidss}`]
}
      const response = await enqueueRequest(() =>
       Hexapi(obj)
      );
     
      const imageMap = response?.[""]?.[0];

      if (imageMap?.synced && imageMap?.orgphotoversion) {
        storedVersion = imageMap.orgphotoversion;
        currentVersion = imageMap.orgphotoversion;
        localStorage.setItem("OrgPhotoVersion", storedVersion);
        break; 
      }

      if (imageMap?.empid != -1 && imageMap?.photo && imageMap.empid !== "-1") {
        const imgID = imageMap.empid.toString();
        const imageUrl = imageMap.photo;
        const version = imageMap.photoversion;
        const OrgDBName = localStorage.getItem("orgdbname");
        const existing = imageStore[imgID];
        if (!existing || existing.version !== version) {
          const blob = base64ToBlob(imageUrl);
          await setImageEntry({ imgID, imageUrl: blob, version, OrgDBName });
          window.dispatchEvent(new CustomEvent("userImageUpdated", { detail: { imgID } }));
          id = imgID;
        }
      }
    }
    return id;
  } catch (error) {
    console.error("Failed to fetch image:", error);
    return null;
  } finally {
    isFetchingImages = false;
  }
}